export const receiptPriceValueKeys = [
  'EmployeeCard.EmployeeCardBalance',
  'Transaction.PaymentDetail.*.PaymentAmount',
  'Transaction.CashWithdrawal',
  'Transaction.Changes',
  'Transaction.DPP',
  'Transaction.Tax',
  'Transaction.TotalPaid',
  'Transaction.TotalPrice',
  'Transaction.YouSave',
  'Transaction.TransactionDetail.*.Price',
  'Transaction.TransactionDetail.*.Total',
  'Transaction.CashBack.PreviousCashBackAmount',
  'Transaction.CashBack.CashBackEarned',
  'Transaction.CashBack.CashBackRedeemed',
  'Transaction.CashBack.CurrentCashBackAmount',
  'TotalPaymentAmount',
  'ProcessedTransactionDetail.*.Price',
  'ProcessedTransactionDetail.*.Total',
  'ProcessedTransactionDetail.Price',
  'ProcessedTransactionDetail.Total',
];
